import { render, staticRenderFns } from "./YagiBuddyDialog.vue?vue&type=template&id=3be7aeea&scoped=true"
import script from "./YagiBuddyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiBuddyDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiBuddyDialog.vue?vue&type=style&index=0&id=3be7aeea&prod&scoped=true&lang=scss"
import style1 from "./YagiBuddyDialog.vue?vue&type=style&index=1&id=3be7aeea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7aeea",
  null
  
)

export default component.exports